<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-09-22 11:23:31
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-02 15:33:40
 * @FilePath: \standard-v5\src\views\TabbarHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="tabber-home">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <van-tabbar v-model="active" fixed placeholder @change="onChange" :safe-area-inset-bottom=true>
      <van-tabbar-item>
        <span>首页</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/home/home_active.png')
                : require('@/assets/home/home_inactive.png')
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('@/assets/home/my_active.png')
                : require('@/assets/home/my_inactive.png')
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'TabbarHome',
  components: {},
  props: {},
  data() {
    return {
      active: 0,
      loginConfig: {}
    }
  },
  watch: {
    $route(val) {
      // console.log('TabbarHome: ', val)
      if(val.name=='Home') this.active = 0
      if(val.name=='Personal') this.active = 1
    }
  },
  computed: {},
  methods: {
    onChange(index) {
      console.log('index', index)
      if (index == 0) {
        this.$router.push({name: 'Home'})
      }
      if (index == 1) {
        this.$router.push({name: 'Personal'})
      }
    }
  },
  created() {
    if(this.$route.name=='Home') this.active = 0
    if(this.$route.name=='Personal') this.active = 1
  },
  activated() {
    // const token = this.$route.query.token
    // console.log('tab activated',token)
  },
  mounted() {
    this.$bus.$on('tabActive', key => {
      this.active = key
    })
  }
}
</script>
<style lang="scss" scoped>
.tabber-home {
}
</style>
